<h1>
  <span *ngIf="isNew">New</span>
  <span *ngIf="!isNew">Edit</span>
  <span> Agent</span>
</h1>
<form [formGroup]="agentForm" class="w100 col gap-16">
  <div class="col gap-8">
    <div class="color-strong">Select Avatar</div>
    <div class="row avatararea gap-8">
      <img
        class="avatar"
        (click)="selectAvatar(avatar, $event)"
        [ngClass]="avatar == agentForm.get('avatar').value ? 'selected' : ''"
        *ngFor="let avatar of llmavatars"
        [src]="frontendserverurl + '/public/llmavatars/' + avatar"
        alt=""
      />
    </div>
  </div>

  <div class="col gap-8 w100">
    <div class="color-strong">Select Tags</div>
    <div class="tagarea row align-center gap-4">
      <rr-badge
        [icon]="tag.icon"
        type="tag"
        (click)="deleteTag(tag.id)"
        *ngFor="let tag of tags"
        >{{ tag.name }}</rr-badge
      >
    </div>
    <div class="row gap-8 w100">
      <rr-select
        [options]="appTags"
        optionName="name"
        optionValue="id"
        class="w100 grow-1"
        #tagSelect
      ></rr-select>
      <rr-btn
        iconStart="add"
        type="Action"
        (click)="addTag(tagSelect.getSelectedOption().id)"
      ></rr-btn>
    </div>
  </div>
  <rr-select
    [options]="industries"
    optionValue="id"
    optionName="name_en"
    formControlName="industryId"
    label="Industry"
  ></rr-select>
  <rr-select
    [options]="statuses"
    optionName="name"
    optionValue="id"
    formControlName="status"
    label="Status"
  ></rr-select>
  <rr-input label="Name" [required]="true" formControlName="name"></rr-input>
  <rr-textarea
    label="Prompt"
    [required]="true"
    formControlName="prompt"
  ></rr-textarea>
  <rr-checkbox
    [checked]="agentForm.value.isDefault"
    (checkedChanged)="agentForm.value.isDefault = $event"
    size="Small"
    >The Default Agent</rr-checkbox
  >

  <div class="row justify-end align-center gap-8 w100">
    <rr-btn (click)="cancel()">Cancel</rr-btn>
    <rr-btn type="Primary" (click)="save()">Save</rr-btn>
  </div>
</form>
<rr-spinner *ngIf="!hidespinner"></rr-spinner>
